<template>
  <div class="pull-left" style="vertical-align: middle">
    <div class="inline-block pull-left">
      <label :for="'file-upload-' + index + '-' + type" class="c-pointer btn btn-default">
        <div class="inline-block" v-if="image" style="line-height: 50px">
          <img :src="image" :id="'img-load' + index + '-' + type" class="h-auto img-responsive inline-block" v-if="image">
        </div>
        <i v-if="!image && type === 1" class="fa fa-picture-o inline-block" style="font-size: 50px"></i>
        <i v-if="!image && type === 2" class="fa fa-picture-o inline-block" style="font-size: 98px"></i>
      </label>
      <input :id="'file-upload-' + index + '-' + type" class="form-control" type="file" style="display: none;" @change="onFileChange">
    </div>
    <!-- Modal -->
    <div class="modal fade" :id="'myModal-' + index + '-' + type" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            <h4 class="modal-title" v-if="type === 1">小圖</h4>
            <h4 class="modal-title" v-if="type === 2">小圖</h4>
          </div>
          <div class="modal-body">
            <img :src="image" class="img-responsive">
            </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">返回</button>
            <!--<button type="button" class="btn btn-primary">Save changes</button>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
export default{
  props: {
    index: Number,
    type: Number,
    imgSrc: String,
    checkLoading: Function
  },
  data () {
    return {
      image: '',
      img: {
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      let imgName = files[0].name.split('.')
      if (imgName.length < 2 || !imgName[imgName.length - 1].match(/(jpg|jpeg|png)$/i)) {
        this.$notify({
          title: '提醒',
          text: '圖片格式錯誤！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        // $('#file-upload').replaceWith($('#file-upload').val(''))
      } else {
        this.createImage(files[0])
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        self.image = img.src
        // $('#img-load' + this.index + '-' + this.type).attr('src', img.src)
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          let valid = self.checkImgSize()
          if (valid) self.checkLoading(this.index, true)
          else self.image = null
        }
      }
      $('.img-size').css('background', 'white')
      reader.readAsDataURL(file)
    },
    checkImgSize () {
      let valid = true
      var self = this
      if (this.type === 1) {
        if ((this.img.width !== 80 || this.img.height !== 60) && this.img.width !== 0 && this.img.height !== 0 && this.$route.name !== 'upCategoryImg') {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳80x60之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          valid = false
        }
        /* else if ((this.img.width !== 800 || this.img.height !== 210) && this.img.width !== 0 && this.img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x210之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } */
      } else if (this.type === 2) {
        if ((this.img.width !== 800 || this.img.height !== 600) && this.img.width !== 0 && this.img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x600之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          valid = false
        }
      }
      return valid
    }
  },
  watch: {
    imgSrc () {
      if (typeof this.imgSrc !== 'undefined') {
        this.image = this.imgSrc
      }
    }
  }
}
</script>
<style scoped>
.modal, .modal * {
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// ImgUpdateTemp.vue?df6c8fde